module.exports = __webpack_public_path__ + "img/82.water_bar.fdd25766.svg";